import { GetCogsDataRequestBodyType } from "@intelligems/ig-types";
import { useMutation } from "@tanstack/react-query";

import { api } from "../api";

const getCogsData = async (data: GetCogsDataRequestBodyType) => {
  const resp = await api.post<string>(`/v2/organizations/cogs-data`, {
    ...data,
  });
  return resp.data;
};
export const useGetCogsData = () => {
  return useMutation<string, Error, GetCogsDataRequestBodyType, any>({
    mutationFn: async (data) => getCogsData(data),
  });
};
